import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
// import {
//   LayoutSideNavigation,
//   LayoutWrapperMain,
//   LayoutWrapperAccountSettingsSideNav,
//   LayoutWrapperTopbar,
//   LayoutWrapperFooter,
//   Footer,
//   Page,
//   UserNav,
// } from '../../components';
// import { TopbarContainer } from '../../containers';

import {
  Heading,
  Page,
  ResponsiveBackgroundImageContainer,
  LayoutSingleColumn,
  NamedLink,
  ExternalLink,
} from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';


import css from './AdobeSignPage.module.css';

export const AdobeSignPage = props => {
  const { scrollingDisabled, intl } = props;

  return (
    // <Page title={'AdobeSignPage'} scrollingDisabled={scrollingDisabled}>
    //   <LayoutSideNavigation>
    //     <LayoutWrapperTopbar>
    //       <TopbarContainer
    //         currentPage="AdobeSignPage"
    //         desktopClassName={css.desktopTopbar}
    //         mobileClassName={css.mobileTopbar}
    //       />
    //     </LayoutWrapperTopbar>
    //     <LayoutWrapperMain>
    //       <div className={css.content}></div>
    //     </LayoutWrapperMain>
    //     <LayoutWrapperFooter>
    //       <Footer />
    //     </LayoutWrapperFooter>
    //   </LayoutSideNavigation>
    // </Page>
    <Page
      title="Thank you!"
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn
        mainColumnClassName={css.layoutWrapperMain}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        {/* <div className={css.content}></div> */}
        <div className={css.contentWrapper}>
          <center>
            <h1 style={{ marginTop: '15vh' }}>Thank you!</h1>
          </center>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

AdobeSignPage.defaultProps = {
  changePasswordError: null,
  currentUser: null,
  resetPasswordInProgress: false,
  resetPasswordError: null,
};

const { bool, func } = PropTypes;

AdobeSignPage.propTypes = {
  changePasswordError: propTypes.error,
  changePasswordInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  onChange: func.isRequired,
  onSubmitChangePassword: func.isRequired,
  passwordChanged: bool.isRequired,
  scrollingDisabled: bool.isRequired,
  resetPasswordInProgress: bool,
  resetPasswordError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

export default AdobeSignPage;
